import { render, staticRenderFns } from "./ExistingGripStrategyList.vue?vue&type=template&id=f20ac21a"
import script from "./ExistingGripStrategyList.vue?vue&type=script&lang=ts"
export * from "./ExistingGripStrategyList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports